import { useParams } from "react-router-dom";
import { useGetWorkspace, useListWorkspaces } from "@/api/orval";

// Resolves the workspace from the :city slug in the URL. The app is URL-driven:
// the city you're viewing is whatever the URL says, not a stored "current city".
export const useCurrentWorkspace = () => {
  const { city } = useParams<{ city: string }>();
  const { data: workspaces } = useListWorkspaces();
  const workspaceId = workspaces?.find((w) => w.slug === city)?.id;

  const { data: workspace, isLoading: isWorkspaceLoading } = useGetWorkspace(
    { workspaceId: workspaceId ?? "" },
    { query: { enabled: !!workspaceId } },
  );

  return { workspace, isWorkspaceLoading, workspaceId };
};
